import * as yup from 'yup';

const validationSchema = yup.object().shape({
  input_driver: yup.object().nullable().required('Selecione um motorista'),
  input_data: yup.string().required('Selecione uma data'),
});

export default validationSchema;
